import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AuthUserListComponent } from './auth-user-list/auth-user-list.component';
/*import { AuthUserComponent } from './auth-user/auth-user.component'*/

import { AuthGuard } from '@core/utilities/auth.guard';
import { Permission } from '@core/literals/permission.literal';
import { AuthUserComponent } from './auth-user/auth-user.component';
import { RedeploymentAuthorize } from '../../core/utilities/redeployment-authorize.guard';
import { Organizations } from '../../shared/literals/shared.literal';

const routes: Routes = [
  {
    path: '',
    component: AuthUserListComponent,
    canActivate: [AuthGuard, (RedeploymentAuthorize(Permission.ViewUsers, undefined))]
  },
  {
    path: 'AuthUser/Detail/:id',
    component: AuthUserComponent,
    canActivate: [AuthGuard, (RedeploymentAuthorize(Permission.CreateUpdateUsers, undefined))]
  }
]
@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: [AuthGuard]
})
export class AuthUsersRoutingModule {

}
